module.exports = __webpack_public_path__ + "img/404.798a7d2e.png";